import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import { url, sitename } from '../../../config';

class AdminNotification extends React.Component {

    static propTypes = {
        content: PropTypes.shape({
          description: PropTypes.string.isRequired,
          data: PropTypes.array.isRequired
        })
    };

    render() {

        const textStyle = {
            color: '#484848',
            backgroundColor: '#F7F7F7',
            fontFamily: 'Arial',
            fontSize: '16px',
            padding: '35px'
        };
        let textBold = {
            fontWeight: 'bold'
        }
        const { content: { description, data, logo } } = this.props;

        return (
            <Layout>
                <Header color="#D85B5F" backgroundColor="#F7F7F7" logo={logo} />
                <Body textStyle={textStyle}>
                    <div>
                        Hello Ministers,
                    </div>
                    <EmptySpace height={20} />
                    {description && <div>
                        {description}
                    </div>}
                    <EmptySpace height={20} />
                    <div>
                        { data.map(item => {
                          return (
                            <span><span style={textBold}>{item.key}:</span> {item.value}<br /></span>
                          )
                        }) }
                    </div>
                </Body>
                <Footer />
                <EmptySpace height={20} />
            </Layout>
        );
    }

}

export default AdminNotification;


// WEBPACK FOOTER //
// src/core/email/template/AdminNotification.js